<template>
  <div class="clinic-card-container">
    <!-- 顶部功能菜单 -->
    <div class="header-menu">
      <div class="menu-items">
        <el-button 
          type="primary" 
          size="medium" 
          class="menu-btn active"
          @click="switchMenu('register')">
          证照登记
        </el-button>
        <el-button 
          type="primary" 
          size="medium" 
          class="menu-btn"
          @click="switchMenu('annual')">
          证照年审
        </el-button>
        <el-button 
          type="primary" 
          size="medium" 
          class="menu-btn"
          @click="switchMenu('extension')">
          证照延期
        </el-button>
        <el-button 
          type="primary" 
          size="medium" 
          class="menu-btn"
          @click="switchMenu('change')">
          变更记录
        </el-button>
        <el-button 
          type="primary" 
          size="medium" 
          class="menu-btn"
          @click="switchMenu('cancel')">
          注销记录
        </el-button>
      </div>
    </div>

    <!-- 主内容区域 -->
    <div class="main-content">
      <!-- 左侧证照列表 -->
      <div class="certificate-list">
        <div class="list-header">
          <span class="header-title">证照名称</span>
          <el-input
            v-model="searchText"
            placeholder="搜索证照名称"
            size="small"
            prefix-icon="el-icon-search"
            class="search-input"
            @input="handleSearch">
          </el-input>
        </div>
        
        <div class="list-content">
          <div 
            v-for="cert in filteredCertificates" 
            :key="cert.id"
            :class="['cert-item', { active: selectedCert.id === cert.id }]"
            @click="selectCertificate(cert)">
            <el-checkbox 
              v-model="cert.checked" 
              @change="handleCheckChange(cert)">
            </el-checkbox>
            <span class="cert-name">{{ cert.name }}</span>
          </div>
        </div>
      </div>

      <!-- 右侧详细信息 -->
      <div class="certificate-detail">
        <div class="detail-header">
          <div class="header-left">
            <span class="title">证照详细信息</span>
            <span class="subtitle" v-if="selectedCert.name">{{ selectedCert.name }}</span>
          </div>
          <div class="header-right">
            <el-button type="primary" size="small" @click="handleNew">新增</el-button>
            <el-button type="warning" size="small" @click="handleModify">修改</el-button>
            <el-button type="danger" size="small" @click="handleCancel">注销</el-button>
            <el-button type="success" size="small" @click="handleExport">导出</el-button>
          </div>
        </div>

        <div class="detail-content">
          <el-table
            :data="certificateDetails"
            border
            style="width: 100%"
            size="small">
            <el-table-column
              prop="type"
              label="证照类型"
              width="120">
            </el-table-column>
            <el-table-column
              prop="name"
              label="证件名称"
              width="180">
            </el-table-column>
            <el-table-column
              prop="needAnnual"
              label="是否年审"
              width="100">
              <template slot-scope="scope">
                <span :class="scope.row.needAnnual ? 'status-yes' : 'status-no'">
                  {{ scope.row.needAnnual ? '是' : '否' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="nextAnnualDate"
              label="下次年审日期"
              width="120">
            </el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              width="100">
              <template slot-scope="scope">
                <el-tag 
                  :type="scope.row.status === '在库' ? 'success' : 'warning'" 
                  size="small">
                  {{ scope.row.status }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="photo"
              label="证照照片"
              width="120">
              <template slot-scope="scope">
                <el-button 
                  type="text" 
                  size="mini" 
                  @click="viewPhoto(scope.row)">
                  查看照片
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="issueDate"
              label="签发日期"
              width="120">
            </el-table-column>
            <el-table-column
              prop="action"
              label="操作"
              width="150">
              <template slot-scope="scope">
                <el-button 
                  type="text" 
                  size="mini" 
                  @click="handleSubmit(scope.row)">
                  提交审核
                </el-button>
                <el-button 
                  type="text" 
                  size="mini" 
                  @click="handleDownload(scope.row)">
                  下载
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 新建下载任务对话框 -->
    <el-dialog
      title="新建下载任务"
      :visible.sync="downloadDialogVisible"
      width="500px"
      :close-on-click-modal="false">
      <div class="download-dialog">
        <div class="dialog-item">
          <label class="dialog-label">网址：</label>
          <span class="dialog-value">http://v8.oa8000.com/驱动装应Jsp/downloadByPath.jsp</span>
        </div>
        <div class="dialog-item">
          <label class="dialog-label">文件名：</label>
          <span class="dialog-value">xls EXCEL文档 未知大小</span>
        </div>
        <div class="dialog-item">
          <label class="dialog-label">下载到：</label>
          <div class="download-path">
            <span class="path-value">D:\360极速浏览器下载</span>
            <el-button type="text" size="mini" @click="browseFolder">浏览</el-button>
          </div>
        </div>
        <div class="storage-info">
          <span>剩余空间：117.89GB</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="downloadDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmDownload">开始下载</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ClinicCard',
  data() {
    return {
      // 当前激活的菜单
      activeMenu: 'register',
      
      // 搜索文本
      searchText: '',
      
      // 选中的证照
      selectedCert: {},
      
      // 下载对话框可见性
      downloadDialogVisible: false,
      
      // 证照列表数据
      certificates: [
        {
          id: 1,
          name: 'AAA级信用企业证照',
          checked: true,
          type: '信用证书',
          needAnnual: true,
          nextAnnualDate: '2018-11-30',
          status: '在库',
          issueDate: '2018-12-28'
        },
        {
          id: 2,
          name: '企业法人营业执照(正本)',
          checked: false,
          type: '营业执照',
          needAnnual: true,
          nextAnnualDate: '2018-11-30',
          status: '在库',
          issueDate: '2018-11-30'
        },
        {
          id: 3,
          name: '双软认证证书',
          checked: false,
          type: '认证证书',
          needAnnual: true,
          nextAnnualDate: '2018-12-27',
          status: '在库',
          issueDate: '2018-08-31'
        },
        {
          id: 4,
          name: '商标注册证书',
          checked: false,
          type: '商标证书',
          needAnnual: true,
          nextAnnualDate: '2018-11-30',
          status: '在库',
          issueDate: '2018-11-30'
        },
        {
          id: 5,
          name: '安全生产许可证照',
          checked: false,
          type: '安全许可',
          needAnnual: true,
          nextAnnualDate: '2018-12-27',
          status: '在库',
          issueDate: '2018-12-27'
        },
        {
          id: 6,
          name: '建筑业企业资质证书(正本)',
          checked: false,
          type: '资质证书',
          needAnnual: true,
          nextAnnualDate: '2018-12-27',
          status: '在库',
          issueDate: '2018-12-27'
        },
        {
          id: 7,
          name: '税务登记证(正本)',
          checked: false,
          type: '税务登记',
          needAnnual: false,
          nextAnnualDate: '-',
          status: '在库',
          issueDate: '2018-12-27'
        },
        {
          id: 8,
          name: '组织机构代码证(副本)',
          checked: false,
          type: '组织机构代码',
          needAnnual: true,
          nextAnnualDate: '2018-11-30',
          status: '在库',
          issueDate: '2018-11-30'
        },
        {
          id: 9,
          name: '组织机构代码证(正本)',
          checked: false,
          type: '组织机构代码',
          needAnnual: true,
          nextAnnualDate: '2018-12-27',
          status: '在库',
          issueDate: '2018-12-27'
        },
        {
          id: 10,
          name: '计算机信息系统集成资质证书(正本)',
          checked: false,
          type: '资质证书',
          needAnnual: true,
          nextAnnualDate: '2018-12-27',
          status: '在库',
          issueDate: '2018-12-27'
        }
      ],
      
      // 证照详细信息
      certificateDetails: []
    };
  },
  
  computed: {
    // 过滤后的证照列表
    filteredCertificates() {
      if (!this.searchText) {
        return this.certificates;
      }
      return this.certificates.filter(cert => 
        cert.name.toLowerCase().includes(this.searchText.toLowerCase())
      );
    }
  },
  
  methods: {
    // 切换菜单
    switchMenu(menu) {
      this.activeMenu = menu;
      // 移除所有按钮的active类
      document.querySelectorAll('.menu-btn').forEach(btn => {
        btn.classList.remove('active');
      });
      // 为当前按钮添加active类
      event.target.classList.add('active');
    },
    
    // 选择证照
    selectCertificate(cert) {
      this.selectedCert = cert;
      this.certificateDetails = [cert];
    },
    
    // 处理复选框变化
    handleCheckChange(cert) {
      if (cert.checked) {
        this.selectedCert = cert;
        this.certificateDetails = [cert];
      }
    },
    
    // 处理搜索
    handleSearch() {
      // 搜索逻辑已在computed属性中处理
    },
    
    // 新增证照
    handleNew() {
      this.$message.info('新增功能开发中');
    },
    
    // 修改证照
    handleModify() {
      if (!this.selectedCert.id) {
        this.$message.warning('请先选择要修改的证照');
        return;
      }
      this.$message.info(`修改 ${this.selectedCert.name}`);
    },
    
    // 注销证照
    handleCancel() {
      if (!this.selectedCert.id) {
        this.$message.warning('请先选择要注销的证照');
        return;
      }
      this.$confirm(`确定要注销"${this.selectedCert.name}"吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success('注销成功');
      });
    },
    
    // 导出证照
    handleExport() {
      this.downloadDialogVisible = true;
    },
    
    // 查看照片
    viewPhoto(cert) {
      this.$message.info(`查看 ${cert.name} 的照片`);
    },
    
    // 提交审核
    handleSubmit(cert) {
      this.$confirm(`确定要提交"${cert.name}"审核吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$message.success('提交审核成功');
      });
    },
    
    // 下载
    handleDownload(cert) {
      this.downloadDialogVisible = true;
    },
    
    // 浏览文件夹
    browseFolder() {
      this.$message.info('浏览文件夹功能开发中');
    },
    
    // 确认下载
    confirmDownload() {
      this.$message.success('开始下载任务');
      this.downloadDialogVisible = false;
    }
  },
  
  mounted() {
    // 默认选中第一个证照
    if (this.certificates.length > 0) {
      this.selectCertificate(this.certificates[0]);
    }
  }
};
</script>

<style lang="less" scoped>
.clinic-card-container {
  height: 100vh;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
  
  .header-menu {
    background-color: #fff;
    padding: 15px 20px;
    border-bottom: 1px solid #e4e7ed;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    
    .menu-items {
      display: flex;
      gap: 10px;
      
      .menu-btn {
        border-radius: 4px;
        font-weight: 500;
        
        &.active {
          background-color: #409eff;
          border-color: #409eff;
        }
        
        &:hover {
          background-color: #66b1ff;
          border-color: #66b1ff;
        }
      }
    }
  }
  
  .main-content {
    flex: 1;
    display: flex;
    padding: 20px;
    gap: 20px;
    overflow: hidden;
    
    .certificate-list {
      width: 300px;
      background-color: #fff;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      display: flex;
      flex-direction: column;
      
      .list-header {
        padding: 15px;
        border-bottom: 1px solid #e4e7ed;
        
        .header-title {
          font-size: 16px;
          font-weight: 600;
          color: #303133;
          margin-bottom: 10px;
          display: block;
        }
        
        .search-input {
          width: 100%;
        }
      }
      
      .list-content {
        flex: 1;
        overflow-y: auto;
        padding: 10px 0;
        
        .cert-item {
          display: flex;
          align-items: center;
          padding: 12px 15px;
          cursor: pointer;
          border-left: 3px solid transparent;
          transition: all 0.3s;
          
          &:hover {
            background-color: #f5f7fa;
          }
          
          &.active {
            background-color: #ecf5ff;
            border-left-color: #409eff;
          }
          
          .cert-name {
            margin-left: 10px;
            font-size: 14px;
            color: #606266;
          }
        }
      }
    }
    
    .certificate-detail {
      flex: 1;
      background-color: #fff;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      display: flex;
      flex-direction: column;
      overflow: hidden;
      
      .detail-header {
        padding: 15px 20px;
        border-bottom: 1px solid #e4e7ed;
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        .header-left {
          .title {
            font-size: 16px;
            font-weight: 600;
            color: #303133;
            display: block;
          }
          
          .subtitle {
            font-size: 14px;
            color: #909399;
            margin-top: 5px;
            display: block;
          }
        }
        
        .header-right {
          display: flex;
          gap: 10px;
        }
      }
      
      .detail-content {
        flex: 1;
        padding: 20px;
        overflow: auto;
        
        .status-yes {
          color: #67c23a;
          font-weight: 500;
        }
        
        .status-no {
          color: #909399;
        }
      }
    }
  }
}

.download-dialog {
  .dialog-item {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    
    .dialog-label {
      width: 80px;
      font-weight: 500;
      color: #606266;
    }
    
    .dialog-value {
      flex: 1;
      color: #909399;
      word-break: break-all;
    }
    
    .download-path {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      
      .path-value {
        color: #909399;
      }
    }
  }
  
  .storage-info {
    margin-top: 10px;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
    text-align: center;
    color: #909399;
    font-size: 14px;
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .main-content {
    flex-direction: column;
    
    .certificate-list {
      width: 100% !important;
      margin-bottom: 20px;
    }
  }
}

// 滚动条样式
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #909399;
}
</style>